// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"AX-z","inlineTitle":"BX-z","sponsoredAdsWrapper":"CX-z","marketplaceRecosWrapper":"DX-z"};